// DTO

import { RefResourceType, RefServiceType } from "../ref/Ref.dto";

export enum S3ResourceContentType {
  Image = "IMAGE",
  Excel = "EXCEL",
  Word = "WORD",
  Pdf = "PDF",
  Text = "TEXT",
  Html = "HTML",
  Dicom = "DICOM",
  Binary = "BINARY",
  Ppt = "PPT",
  Zip = "ZIP",
}

export enum S3ResourceStatus {
  Temp = "TEMP",
  Online = "ONLINE",
}

export interface S3TempFile {
  identifier?: string;
  resourceId?: bigint;
  name: string;
  key: string;
}

export interface S3PresignedUrl {
  identifier?: string;
  method: string;
  bucket: string;
  key: string;
  url: string;
  previewUrl: string;
  downloadUrl: string;
}

export interface CreatePresignedPostUrlRequest {
  service: RefServiceType;
  resourceType: RefResourceType;
  resourceId?: bigint;
  contentType: S3ResourceContentType;
  name: string;
  identifier?: string;
}

export interface CreatePresignedPostUrlResponse {
  presignedUrl: S3PresignedUrl;
}

//

export interface CreatePresignedGetUrlRequest {
  bucket: string;
  key: string;
}

export interface CreatePresignedGetUrlResponse {
  presignedUrl: S3PresignedUrl;
}

export type CopyTempToLiveBucketRequest = S3TempFile;

export interface CopyTempToLiveBucketResponse {
  presignedUrl: S3PresignedUrl;
}

export interface CopyTempsToLiveBucketRequest {
  temps: Array<S3TempFile>;
}

export interface CopyTempsToLiveBucketResponse {
  presignedUrls: Array<S3PresignedUrl>;
}

// GetChecksum

export interface GetS3ObjectChecksumRequest {
  bucket: string;
  key: string;
  algorithm: "MD5";
}

export interface GetS3ObjectChecksumResponse {
  checksum: string;
  fileSize: number;
}

// GetFileType

export interface GetS3ObjectFileInfoRequest {
  bucket: string;
  key: string;
}

export interface GetS3ObjectFileInfoResponse {
  ext: string;
  mime: string;
  fileSize: number;
}

export type S3Object = {
  key: string;
  bucket: string;
};

export type S3ObjectWithFileInfo = {
  key: string;
  bucket: string;
  ext: string;
  mime: string;
  fileSize: number;
};

export interface RetrieveS3ObjectFileInfoBulkRequest {
  s3Objects: Array<S3Object>;
}

export interface RetrieveS3ObjectFileInfoBulkResponse {
  s3ObjectsWithFileInfo: Array<S3ObjectWithFileInfo>;
}
